import { api } from '@/shared/services/baseApiClient';
import { config } from '@/config/config';
import urljoin from 'url-join';
import { AnswerViewModel } from '../models/answers/answerViewModel';
import { GetAnswersResponseViewModel } from '@/features/bots/models/answers/getAnswersResponseViewModel';
import { AnswerListItemViewModel } from '../models/answers/answerListItemViewModel';
import { UpdateAnswerViewModel } from '@/features/bots/models/answers/updateAnswerViewModel';
import { CreateAnswerViewModel } from '@/features/bots/models/answers/createAnswerViewModel';

class AnswersApiService {
  private version = 'v1';

  public async getAnswers(workspaceId: string): Promise<AnswerListItemViewModel[]> {
    const response: GetAnswersResponseViewModel = await api.send(
      'GET',
      urljoin(config().answersHost, this.version, workspaceId, 'answers'),
    );
    return response.results;
  }

  public getAnswer(workspaceId: string, answerId: string): Promise<AnswerViewModel> {
    return api.send('GET', urljoin(config().answersHost, this.version, workspaceId, 'answers', answerId));
  }

  public createAnswer(workspaceId: string, request: CreateAnswerViewModel): Promise<AnswerViewModel> {
    return api.send('POST', urljoin(config().answersHost, this.version, workspaceId, 'answers'), request);
  }

  public updateAnswer(workspaceId: string, answerId: string, request: UpdateAnswerViewModel): Promise<AnswerViewModel> {
    return api.send('PATCH', urljoin(config().answersHost, this.version, workspaceId, 'answers', answerId), request);
  }

  public deleteAnswer(workspaceId: string, answerId: string): Promise<void> {
    return api.send('DELETE', urljoin(config().answersHost, this.version, workspaceId, 'answers', answerId));
  }
}

export const answersApi = new AnswersApiService();
